import { Controller } from "stimulus";

export default class extends Controller
{
    connect()
    {
        if(window.App.EDIT_MODE) this.element.classList.add("active");
        
        this.element.addEventListener("click", e =>
        {
            if(this.element.classList.contains("active"))
            {
                this.element.classList.remove("active");
                let event = new CustomEvent("disable-edit-mode");
                let res = window.dispatchEvent(event);
            }
            else
            {
                this.element.classList.add("active");
                let event = new CustomEvent("enable-edit-mode");
                let res = window.dispatchEvent(event);
            }
        })
    }
    
}